export default {
  location: (id?: string) => (!id ? "/menu" : `/menu/${id}`),
  area: (id?: string) => (!id ? "/section" : `/section/${id}`),
  exhibit: (id?: string, viewsBy?: string) =>
    !id ? `/topic` : `/topic/${id}?feature=${viewsBy}`,
};
